export default "__VITE_ASSET__j46AGJv7__"